import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import type { MailOutboxItem } from "@/lib/notification.api";

export function formatNotificationDateTime(value: string): string {
  return format(parseISO(value), "dd MMM yyyy HH:mm", { locale: fr });
}

export function getMailOutboxStatusLabel(status: MailOutboxItem["status"]): string {
  if (status === "sent") return "Envoyé";
  if (status === "failed") return "Échec";
  return "En attente";
}

export function getMailOutboxStatusTone(status: MailOutboxItem["status"]): string {
  if (status === "sent") return "border-success-border bg-success-bg text-success-text";
  if (status === "failed") return "border-danger-border bg-danger-bg text-danger-text";
  return "border-warning-border bg-warning-bg text-warning-text";
}
